(() => {
'use strict';
const bounds = {
  stores:[1,10000,true],skus:[1,1000000,true],percent:[0,100,false],
  large:[1,10000,true],area:[1,100000,false],minutes:[0,1440,false],
  labour:[0,10000,false],print:[0,100,false],esl:[0,10000,false],
  hub:[0,100000,false],app:[0,100000,false]
};
function parseNumber(raw,min,max,integer=false) {
  const text = String(raw).trim();
  const message = 'Enter '+(integer?'a whole number':'a number')+' between '+min.toLocaleString('en-GB')+' and '+max.toLocaleString('en-GB')+'.';
  if (!/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(text)) return {error:message};
  const value = Number(text.replaceAll(',',''));
  if (!Number.isFinite(value) || value < min || value > max || (integer && !Number.isInteger(value))) return {error:message};
  return {value};
}
function calculateESL(v) {
  for (const key of ['stores','skus','percent','minutes','labour','print','esl','hub','app']) {
    if (parseNumber(String(v[key]),...bounds[key]).error) throw new RangeError('Invalid '+key);
  }
  if (![12,26,52,104,365].includes(v.frequency) || !Number.isInteger(v.large) || v.large<0 || v.large>v.stores) throw new RangeError('Invalid frequency or large stores');
  if (v.large>0 && parseNumber(String(v.area),...bounds.area).error) throw new RangeError('Invalid selling area');
  const perLarge = v.large>0 ? Math.max(1,Math.ceil(v.area/30)) : 0;
  const hubs = (v.stores-v.large) + v.large*perLarge;
  const changes = v.stores*v.skus*v.percent/100*v.frequency;
  const hours = changes*v.minutes/60;
  const labourCost = hours*v.labour;
  const printCost = changes*v.print;
  const manual = labourCost+printCost;
  const initial = v.stores*v.skus*v.esl+hubs*v.hub;
  const software = hubs*v.app*12;
  const benefit = manual-software;
  return {hubs,perLarge,changes,hours,labourCost,printCost,manual,initial,software,benefit,
    year1:initial+software,year1Benefit:manual-initial-software,
    manual3:manual*3,esl3:initial+software*3,payback:benefit>0?initial/benefit*12:null};
}
function resultPresentation(result) {
  const year1State=result.year1Benefit>0?'positive':result.year1Benefit<0?'negative':'neutral';
  const ongoingState=result.benefit>0?'positive':result.benefit<0?'negative':'neutral';
  return {
    year1State,
    ongoingState,
    year1Label:year1State==='positive'?'Year 1 net benefit':year1State==='negative'?'Year 1 net cost':'Year 1 break-even',
    ongoingLabel:ongoingState==='positive'?'Year 2+ net benefit per year':ongoingState==='negative'?'Year 2+ net cost per year':'Year 2+ break-even',
    year1Amount:Math.abs(result.year1Benefit),
    ongoingAmount:Math.abs(result.benefit),
    firstYearNote:year1State==='positive'
      ?'Modelled manual cost minus modelled first-year label, hub and app costs.'
      :year1State==='negative'
        ?'Modelled first-year label, hub and app costs exceed manual label costs.'
        :'Modelled manual and first-year ESL costs are equal.'
  };
}
if (typeof module !== 'undefined' && module.exports) module.exports={parseNumber,calculateESL,resultPresentation};
if (typeof window === 'undefined' || customElements.get('esl-savings-calculator')) return;
customElements.define('esl-savings-calculator',class extends HTMLElement {
  connectedCallback() {
    if(this.initialised) return;
    this.initialised=true;
    this.step=0;this.largeChoice=null;this.costChoice=null;this.startTracked=false;this.lastValues=null;
    this.storageKey='vs-labs-esl-estimate-v1';
    this.form=this.querySelector('[data-calculator]');
    this.form.reset();
    this.form.elements.esl.value='3';this.form.elements.hub.value='300';this.form.elements.app.value='100';
    this.money=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',maximumFractionDigits:0});
    this.number=new Intl.NumberFormat('en-GB',{maximumFractionDigits:0});
    this.form.addEventListener('input',event=>{
      this.trackStart();
      if(event.target.name) this.clearFieldError(event.target.name);
      this.syncChips();
    });
    this.form.addEventListener('change',event=>{this.trackStart();if(event.target.name)this.clearFieldError(event.target.name);});
    this.addEventListener('click',event=>{
      const button=event.target.closest('button');
      if(!button || !this.contains(button)) return;
      if(button.dataset.fill){
        this.trackStart();
        this.form.elements[button.dataset.fill].value=button.dataset.value;
        this.clearFieldError(button.dataset.fill);this.syncChips();
      } else if(button.hasAttribute('data-large')){
        this.trackStart();
        this.largeChoice=button.dataset.large;
        this.querySelector('[data-large-fields]').hidden=this.largeChoice!=='yes';
        this.querySelector('[data-choice-error="largeChoice"]').hidden=true;
        this.querySelectorAll('[data-large]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      } else if(button.hasAttribute('data-cost')){
        this.trackStart();
        this.costChoice=button.dataset.cost;
        this.querySelector('[data-cost-fields]').hidden=this.costChoice!=='custom';
        this.querySelector('[data-choice-error="costChoice"]').hidden=true;
        this.querySelectorAll('[data-cost]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      } else if(button.hasAttribute('data-back')) this.showStep(Math.max(0,this.step-1));
      else if(button.hasAttribute('data-edit')){
        this.clearResults();this.showStep(0);
      }
    });
    this.form.addEventListener('submit',event=>{
      event.preventDefault();
      this.trackStart();
      if(!this.validateStep(this.step)) return;
      if(this.step<4) this.showStep(this.step+1);
      else {
        for(let step=0;step<4;step++) {
          if(!this.validateStep(step,false)){this.showStep(step);this.validateStep(step);return;}
        }
        const values=this.values();
        const result=calculateESL(values);
        this.lastValues=values;
        this.renderResult(result);
        this.track('completed');
        this.track('result',{year1_result:result.year1Benefit<0?'cost':result.year1Benefit>0?'benefit':'break_even',ongoing_result:result.benefit<0?'cost':result.benefit>0?'benefit':'break_even'});
      }
    });
    const leadForm=this.querySelector('.esl-lead-form');
    if(leadForm)leadForm.addEventListener('submit',()=>{
      if(!leadForm.checkValidity())return;
      this.saveForReturn();
      this.track('email_submission');
    });
    this.syncChips();this.clearResults();this.showStep(0,false);
    this.restoreAfterSignup();
  }
  track(action,details={}) {
    const payload={event:'vs_lead_magnet',lead_magnet:'esl_savings_calculator',action,...details};
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('vs-labs:lead-magnet',{detail:payload}));
  }
  trackStart() {
    if(this.startTracked)return;
    this.startTracked=true;this.track('started');
  }
  saveForReturn() {
    if(!this.lastValues)return;
    try{sessionStorage.setItem(this.storageKey,JSON.stringify({values:this.lastValues,largeChoice:this.largeChoice,costChoice:this.costChoice}));}catch(error){/* The estimate remains visible if storage is unavailable. */}
  }
  restoreAfterSignup() {
    const marker=this.querySelector('[data-lead-return]');
    if(!marker)return;
    let saved=null;
    try{saved=JSON.parse(sessionStorage.getItem(this.storageKey));sessionStorage.removeItem(this.storageKey);}catch(error){saved=null;}
    if(saved?.values){
      const v=saved.values;
      this.largeChoice=saved.largeChoice||'no';this.costChoice=saved.costChoice||'estimate';
      for(const key of ['stores','skus','percent','frequency','large','area','minutes','labour','print','esl','hub','app'])if(v[key]!==undefined&&this.form.elements[key])this.form.elements[key].value=String(v[key]);
      this.querySelector('[data-large-fields]').hidden=this.largeChoice!=='yes';
      this.querySelector('[data-cost-fields]').hidden=this.costChoice!=='custom';
      this.querySelectorAll('[data-large]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.large===this.largeChoice)));
      this.querySelectorAll('[data-cost]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.cost===this.costChoice)));
      this.syncChips();this.lastValues=this.values();this.renderResult(calculateESL(this.lastValues));
    }else this.querySelector('[data-follow]').hidden=false;
    this.track(marker.dataset.leadReturn==='success'?'email_success':'email_error');
    marker.focus({preventScroll:true});marker.scrollIntoView({block:'center',behavior:'auto'});
  }
  clearFieldError(name) {
    const node=this.querySelector('[data-field-error="'+name+'"]');
    if(node) node.hidden=true;
    this.form.elements[name]?.removeAttribute('aria-invalid');
  }
  syncChips() {
    this.querySelectorAll('[data-fill]').forEach(b=>{
      const field=this.form.elements[b.dataset.fill];
      const parsed=parseNumber(field.value,...bounds[b.dataset.fill]);
      b.setAttribute('aria-pressed',String(!parsed.error&&parsed.value===Number(b.dataset.value)));
    });
  }
  validateStep(step,focus=true) {
    const groups=[['stores','skus'],['percent','frequency'],this.largeChoice==='yes'?['large','area']:[],this.costChoice==='custom'?['minutes','labour','print']:[],['esl','hub','app']];
    const choice=step===2?'largeChoice':step===3?'costChoice':null;
    if(choice&&!this[choice]){
      const error=this.querySelector('[data-choice-error="'+choice+'"]');
      error.textContent=step===2?'Choose Yes or No to continue.':'Choose our estimate or enter your own costs.';
      error.hidden=false;
      if(focus)this.querySelector(step===2?'[data-large]':'[data-cost]').focus();
      return false;
    }
    let first=null;
    for(const key of groups[step]){
      const input=this.form.elements[key];
      let message;
      if(key==='frequency') message=['12','26','52','104','365'].includes(input.value)?null:'Choose how often labels change.';
      else {
        const limits=[...bounds[key]];
        if(key==='large')limits[1]=Number(this.form.elements.stores.value.replaceAll(',',''));
        message=parseNumber(input.value,...limits).error;
      }
      const error=this.querySelector('[data-field-error="'+key+'"]');
      error.hidden=!message;error.textContent=message||'';
      input.setAttribute('aria-invalid',String(Boolean(message)));
      if(message&&!first)first=input;
    }
    if(first&&focus){
      const details=first.closest('details');if(details)details.open=true;
      first.focus();
    }
    return !first;
  }
  values() {
    const v={};
    for(const key of ['stores','skus','percent','esl','hub','app'])v[key]=parseNumber(this.form.elements[key].value,...bounds[key]).value;
    v.frequency=Number(this.form.elements.frequency.value);
    v.large=this.largeChoice==='yes'?parseNumber(this.form.elements.large.value,1,v.stores,true).value:0;
    v.area=this.largeChoice==='yes'?parseNumber(this.form.elements.area.value,...bounds.area).value:0;
    Object.assign(v,this.costChoice==='estimate'?{minutes:2,labour:15,print:.07}:Object.fromEntries(['minutes','labour','print'].map(k=>[k,parseNumber(this.form.elements[k].value,...bounds[k]).value])));
    return v;
  }
  showStep(step,focus=true){
    this.step=step;
    this.form.hidden=false;this.querySelector('[data-complete]').hidden=true;
    this.querySelectorAll('[data-step]').forEach(el=>el.hidden=Number(el.dataset.step)!==step);
    this.querySelector('[data-progress]').textContent='Step '+(step+1)+' of 5 · '+['Your stores','Label changes','Store coverage','Manual costs','Review'][step];
    this.querySelector('progress').value=step+1;
    this.querySelector('[data-back]').hidden=step===0;
    this.querySelector('[data-next]').textContent=step===4?'Calculate my estimate':'Continue';
    if(step===4)this.review();
    if(focus){
      this.querySelector('[data-step="'+step+'"] h2').focus({preventScroll:true});
      this.querySelector('.esl-conversation').scrollIntoView({block:'start',behavior:'auto'});
    }
  }
  review(){
    const v=this.values();
    const cadence=this.form.elements.frequency.selectedOptions[0].textContent;
    const rows=[
      ['Your stores',this.number.format(v.stores)+' '+(v.stores===1?'store':'stores')+' · '+this.number.format(v.skus)+' '+(v.skus===1?'label':'labels')+' each'],
      ['Label changes',v.percent+'% changed '+cadence.toLowerCase()],
      ['Large stores',v.large>0?v.large+' '+(v.large===1?'store':'stores')+' · '+this.number.format(v.area)+' m² average selling area':'None'],
      ['Manual update',v.minutes+' minutes at '+this.money.format(v.labour)+'/hour + £'+v.print.toFixed(2)+' printing']
    ];
    const list=this.querySelector('[data-review]');list.replaceChildren();
    for(const [label,value] of rows){
      const term=document.createElement('dt');term.textContent=label;
      const description=document.createElement('dd');description.textContent=value;
      list.append(term,description);
    }
  }
  clearResults(){
    this.querySelector('.esl-results').hidden=true;
    this.querySelector('[data-neutral]').hidden=true;
    for(const selector of ['[data-model]','[data-follow]'])this.querySelector(selector).hidden=true;
    this.querySelectorAll('[data-result]').forEach(el=>el.textContent='');
    this.querySelector('[data-announcement]').textContent='';
  }
  renderResult(r){
    const v=this.values();
    const presentation=resultPresentation(r);
    const put=(key,value)=>this.querySelectorAll('[data-result="'+key+'"]').forEach(el=>el.textContent=value);
    for(const key of ['manual','initial','software','year1','manual3','esl3','labourCost','printCost'])put(key,this.money.format(r[key]));
    put('year1Benefit',this.money.format(presentation.year1Amount));
    put('benefit',this.money.format(presentation.ongoingAmount));
    put('year1Label',presentation.year1Label);put('benefitLabel',presentation.ongoingLabel);
    for(const key of ['hubs','changes','hours'])put(key,this.number.format(r[key]));
    put('payback',r.payback===null?'Not reached':r.payback===0?'Immediate':r.payback<1?'Under 1 month':new Intl.NumberFormat('en-GB',{maximumFractionDigits:1}).format(r.payback)+' months');
    put('firstYearNote',presentation.firstYearNote);
    this.querySelector('.esl-head').dataset.resultState=presentation.year1State;
    this.querySelector('.esl-ongoing').dataset.resultState=presentation.ongoingState;
    const standardStores=v.stores-v.large;
    put('hubExplanation',v.large>0?
      'Hub estimate: '+standardStores+' standard '+(standardStores===1?'store':'stores')+' × 1 hub + '+v.large+' large '+(v.large===1?'store':'stores')+' × '+r.perLarge+' '+(r.perLarge===1?'hub':'hubs')+' = '+r.hubs+' '+(r.hubs===1?'hub':'hubs')+'. Large-store hubs use average selling area ÷ 30 m², rounded up per store. Coverage is a planning assumption and needs a site check.':
      'Hub estimate: '+v.stores+' standard '+(v.stores===1?'store':'stores')+' × 1 hub = '+r.hubs+' '+(r.hubs===1?'hub':'hubs')+'. Actual coverage needs a site check.');
    this.querySelector('[data-neutral]').hidden=true;
    this.querySelector('.esl-results').hidden=false;
    for(const selector of ['[data-model]','[data-follow]'])this.querySelector(selector).hidden=false;
    this.form.hidden=true;this.querySelector('[data-complete]').hidden=false;
    this.querySelector('[data-progress]').textContent='Your estimate is ready';
    this.querySelector('.esl-results').focus({preventScroll:true});
    this.querySelector('.esl-results').scrollIntoView({block:'start',behavior:'auto'});
    this.querySelector('[data-announcement]').textContent='Estimate ready. '+presentation.year1Label+' '+this.money.format(presentation.year1Amount)+'.';
  }
});
})();
